export default __webpack_public_path__ + "static/media/kybpending.951bbd85.svg";